export default __webpack_public_path__ + "static/media/banner-02.dfd4ace0.png";